import { defineStyle } from '@chakra-ui/styled-system';
import InputTheme from '../Input/Input.theme';
import { rem } from '../../../utils/utils';

const TextareaTheme = defineStyle({
  baseStyle: {
    ...InputTheme.baseStyle?.field,
    display: 'block',
    minHeight: '96',
    padding: rem('11'),
  },
});

export default TextareaTheme;
